import { render, staticRenderFns } from "./Page004.vue?vue&type=template&id=4413e327&scoped=true&"
import script from "./Page004.vue?vue&type=script&lang=js&"
export * from "./Page004.vue?vue&type=script&lang=js&"
import style0 from "./Page004.vue?vue&type=style&index=0&id=4413e327&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4413e327",
  null
  
)

export default component.exports